import { Injectable } from '@angular/core';
import {FooterAuth} from "../model/footer-auth.model";

@Injectable({
  providedIn: 'root'
})
export class FooterAuthService {
  model: FooterAuth;

  constructor() { }

  setFooterAuth(model: FooterAuth) {
    this.model = new FooterAuth(model);
  }
}
